import * as React from "react";
export default React.memo(function SvgSorting(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" width={12} height={12} fill="none" viewBox="0 0 12 12" role="presentation" {...props}><path stroke="#999" strokeLinecap="round" strokeWidth={1.25} d="m3 7.5 3 3 3-3M9 4.5l-3-3-3 3" /></svg>;
});